<template>
	<v-overlay :model-value="value" class="align-center justify-center" contained persistent transition="none">
		<v-img class="loader" :width="size ?? 'auto'" max-width="100"/>
	</v-overlay>
</template>

<script>

export default {
	name: "Loader",
	props: ["value", "size"]
}
</script>